module.exports = __webpack_public_path__ + "img/web-solution.82568ad8.svg";